import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    ExternalConsignmentLinkColumn,
    MultilineColumn,
    MultilineDateTimeColumn,
    MultilineNumberColumn,
  } = columns(data);

  return [
    {
      Header: 'CARDIT',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('Consignment ID', 'cardit.consignmentId')),
        new MultilineDateTimeColumn('Consignment completion', 'cardit.consignmentCompletionDate'),
        new MultilineColumn('Origin', 'cardit.origin'),
        new MultilineColumn('Destination', 'cardit.destination'),
        new MultilineColumn('Transport', 'cardit.transport'),
        new MultilineNumberColumn('Receptacles', 'cardit.receptacles'),
        new MultilineNumberColumn('Weight', 'cardit.weight'),
      ],
    },
    {
      Header: 'RESDIT',
      columns: [
        new MultilineColumn('Sending mailbox', 'resdit.sendingMailbox'),
        new MultilineColumn('Event', 'resdit.event'),
        new MultilineDateTimeColumn('Event date', 'resdit.eventDate'),
        new MultilineNumberColumn('Receptacles', 'resdit.receptacles'),
      ],
    },
  ];
};
